<template>
  <v-data-table
    fixed-header
    :headers="headers"
    :items="items"
    :items-per-page="-1"
	:footer-props="{
		'items-per-page-options':[15, 30, 50, 100, -1]
	}"
    :height="height"
	:loading="loading"
	v-resize="onWindowResize"
	item-key="sku"
	:single-expand="!singleExpand"
	:expanded.sync="expanded"
	show-expand
	:search="search"
  >
	<template v-slot:item.status="{ item }">
		<v-autocomplete
		v-model="item.status"
		:items="['Good', 'w/ Quantity Descrepancy', 'w/ Price Descrepancy']"
		></v-autocomplete>
    </template>

	<template v-slot:item.itemNumber="{ item }">
		<span v-if="item.status === 'duplicate'" class="red--text font-weight-medium">{{ item.itemNumber }}</span>
		<span v-else>{{ item.itemNumber }}</span>
    </template>

	<template v-slot:item.sku="{item}">
		<span v-if="item.sku === 'dummySKU'"></span>
		<span v-else >{{ item.sku }}</span>
	</template>

	<template v-slot:item.skuStatus="{item}">
		<v-chip v-if="item.skuStatus" dense color="success" x-small>True</v-chip>
		<v-chip v-else dense color="error" x-small>False</v-chip>
	</template>

	<template v-slot:item.costStatus="{item}">
		<v-chip v-if="item.costStatus" dense color="success" x-small>True</v-chip>
		<v-chip v-else dense color="error" x-small>False</v-chip>
	</template>

	<template v-slot:item.qtyStatus="{item}">
		<v-chip v-if="item.qtyStatus" dense color="success" x-small>True</v-chip>
		<v-chip v-else dense color="error" x-small>False</v-chip>
	</template>

	<template v-slot:expanded-item="{ headers, item }">
		<td :colspan="headers.length">
			<tr class="remove-hover">
				<td>
					<v-list-item-content>
						<v-list-item-title><strong>UPC</strong></v-list-item-title>
						<v-list-item-subtitle style="width: 100px;">{{ item.upc }}</v-list-item-subtitle>
					</v-list-item-content>
				</td>
				<td>
					<v-list-item-content>
						<v-list-item-title><strong>ASIN</strong></v-list-item-title>
						<v-list-item-subtitle style="width: 100px;">{{ item.asin }}</v-list-item-subtitle>
					</v-list-item-content>
				</td>
				<td>
					<v-list-item-content>
						<v-list-item-title><strong>Description</strong></v-list-item-title>
						<v-list-item-subtitle style="width: 200px;">{{ item.description }}</v-list-item-subtitle>
					</v-list-item-content>
				</td>
			</tr>
		</td>
    </template>

	<template v-slot:progress>
		<span></span>
	</template>
  </v-data-table>
</template>

<script>
export default {
    props: {
		items: {
			type: Array,
			required: true
		},
		headers: {
			type: Array,
			required: true
		},
		loading: {
			type: Boolean,
			required: true
		},
		singleExpand: {
			type: Boolean,
			required: true
		},
		search: {
			type: String
		}
    },
    data: () => ({
		height: 500,
		expanded: []
	}),
	mounted(){
		this.onWindowResize()
	},
    methods: {
        onWindowResize(){
			this.height = window.innerHeight - 370
		}
    }
}
</script>

<style scoped>
tr.remove-hover:hover{
	background-color: unset !important;
    color: unset !important;
}
</style>